import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.6212 6.96967C19.9141 7.26256 19.9141 7.73744 19.6212 8.03033L10.0909 17.5607L5.46967 12.9394C5.17678 12.6465 5.17678 12.1717 5.46967 11.8788C5.76256 11.5859 6.23744 11.5859 6.53033 11.8788L10.0909 15.4393L18.5606 6.96967C18.8535 6.67678 19.3283 6.67678 19.6212 6.96967Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol